<template lang="pug">
v-footer.pa-0
  .w-100
    .secondary.darken-3
      v-container.main-footer-top.py-6
        .mx-auto
          custom-title(type="section", dark) FALE CONOSCO
          .mt-4
            .text-body-2.mb-6.mb-sm-2.d-flex.flex-column.flex-sm-row(
              v-for="({ sector, name, tel, email }, i) in staff",
              :key="i"
            )
              span.grey--text.text--lighten-2 {{ sector }}:
              span.grey--text.text--lighten-1.ml-1(v-if="name") {{ name }}
              a.primary--text.ml-2.text-decoration-none(
                v-if="tel",
                :href="getWhatsappLinkFromPhone(tel)",
                target="_blank"
              )
                v-icon(color="primary", small, left) fab fa-whatsapp
                span {{ tel }}
              a.grey--text.text--lighten-1.text-decoration-none(
                v-if="email",
                :href="'mailto:' + email",
                target="_blank"
              )
                span.mx-2(v-if="!xs") |
                v-icon(color="grey lighten-1", small, left) fas fa-envelope
                span {{ email }}
        nav.d-flex.flex-wrap.justify-center.justify-md-end
          v-btn.font-weight-bold.px-1.text-none.ml-2(
            v-for="(route, i) in menu",
            :key="i",
            :to="route.path",
            color="grey lighten-2",
            text
          ) {{ route.name }}
        .d-flex.mx-auto.mr-md-0.ml-md-auto
          .ml-2(v-for="(s, i) in social", :key="i")
            tooltip.d-block(:tip="s.title", bottom)
              v-btn(
                :href="s.link",
                color="grey lighten-2",
                target="_blank",
                fab,
                depressed,
                x-small
              )
                v-icon(color="grey darken-3") {{ s.icon }}
    v-divider.black
    .grey.darken-4.pa-4.d-flex.flex-column.flex-sm-row.align-center.justify-space-around
      span.white--text.text-center.py-2.text-body-2 {{ name }} © 2020. Todos os direitos reservados.
      a.mt-4.mt-sm-0(href="https://www.mrxweb.com.br/", target="_blank")
        img.logo-mrx(
          src="/img/mrx.svg",
          alt="MRX Web Sites",
          title="MRX Web Sites"
        )
</template>

<script>
import Tooltip from "@/components/tools/Tooltip";
import CustomTitle from "@/components/others/CustomTitle";
import { menu } from "@/config.js";
import { getWhatsappLinkFromPhone } from "@/components/utils.js";

export default {
  data: () => ({
    menu,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    name() {
      return this.$rest("informations").item.name;
    },
    social() {
      return [
        {
          title: "Facebook",
          link: this.informations.facebook,
          icon: "fab fa-facebook-f",
        },
        {
          title: "Instagram",
          link: this.informations.instagram,
          icon: "fab fa-instagram",
        },
        {
          title: "Youtube",
          link: this.informations.youtube,
          icon: "fab fa-youtube",
        },
      ];
    },
    staff() {
      return this.$rest("staff").list;
    },
    xs() {
      return this.$vuetify.breakpoint.xs;
    },
  },
  methods: {
    getWhatsappLinkFromPhone,
  },
  beforeCreate() {
    this.$rest("staff").get();
  },
  components: {
    Tooltip,
    CustomTitle,
  },
};
</script>

<style>
.main-footer-top {
  display: grid;
  grid-template:
    "contact nav" max-content
    "contact ." auto
    "contact social" max-content / max-content auto;
  gap: 16px;
  align-items: center;
}
@media screen and (max-width: 960px) {
  .main-footer-top {
    grid-template:
      "contact"
      "nav"
      "social";
  }
}
.main-footer-top > :nth-child(1) {
  grid-area: contact;
}
.main-footer-top > :nth-child(2) {
  grid-area: nav;
}
.main-footer-top > :nth-child(3) {
  grid-area: social;
}
.logo-mrx {
  height: 20px;
  filter: brightness(0) invert(1);
}
</style>
